import React from 'react'
import { useState,useEffect } from 'react';
import {Button} from "reactstrap";
import { getLineupsByOrganizer,createLineup,updateLineup,deleteLineup } from '../../../api';
import ListCard from "../../../components/common/ListCard/ListCard";
import { images } from '../../../assets/images';
import  LineupModal from '../../Events/EditQuickEventV2/Components/LineupModal';
import ConfirmationDialog from '../../../components/common/ConfirmationDialog';
import { PulseLoader } from "react-spinners";
import { LineupData } from '../../Events/EditQuickEventV2/types';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from 'react-toastify';
import ImageCropper from '../../../components/common/ImageCropper/ImageCropper';
import { useNightMode } from "../../../contexts/NightModeContext";
import Background from "../../Login/Background";
import PageHeader from "../../../components/common/PageHeader/PageHeader";
const Lineup = () => {
    const { isNightMode } = useNightMode();
    interface LineupItem {
        lineupId: string;
        artistImage: string;
        name: string;
        tagLine?: string;
        description: string;
        eventId: string;
        createdDate: string;
        isActive: boolean;
        event?: { eventId: string; eventName: string };
    }
    const [lineupData, setLineupData] = useState<LineupItem[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isLineupModalOpen, setIsLineupModalOpen] = useState(false);
    const [editingLineup, setEditingLineup] = useState<LineupData | undefined>(undefined);
    const [isCropperOpen, setIsCropperOpen] = useState(false);
    const [fileToCrop, setFileToCrop] = useState<File | null>(null);
    const [croppedFile, setCroppedFile] = useState<File | null>(null);


    useEffect(() => {
        getLineuplist();
    }, []);
    const getLineuplist = async () => {
        try {
            setIsLoading(true);
            const eventData = localStorage.getItem("eventData");
            if (eventData) {
                const eventId = JSON.parse(eventData).eventId;
                const response = await getLineupsByOrganizer();
                const lineups = response?.data;
                if (lineups) {
                    const filteredLineups = lineups.filter(
                        (item: LineupItem) => item.eventId === eventId
                    );
                    setLineupData(filteredLineups);
                    console.log("Filtered Lineups:", filteredLineups);
                }
            }
        } catch (error) {
            console.error("Error fetching lineup data:", error);
        } finally {
            setIsLoading(false);
        }
    };

// Lineup handlers
const handleAddLineup = () => {
    setEditingLineup(undefined);
    setIsLineupModalOpen(true);
  };

  const handleEditLineup = (lineup: LineupItem) => {
    setEditingLineup({
      lineupId: lineup.lineupId,
      name: lineup.name,
      description: lineup.description,
      tagLine: lineup.tagLine || "",
      artistImage: lineup.artistImage || "",
      organizerId: lineup.event?.eventId || "", // default fallback
      sortOrder: 0, // or calculate from index
      socialMedia: [], // empty default
      eventId: lineup.eventId,
      createdDate: lineup.createdDate,
      isActive: lineup.isActive,
    });
    setIsLineupModalOpen(true);
  };
    const handleImageSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        if (file.size > 2 * 1024 * 1024) {
          toast.error("Max file size is 2MB");
          return;
        }

        setFileToCrop(file);
        setIsCropperOpen(true);
      }; 

    const handleSaveLineup = async (lineup: LineupData) => {
    setIsLoading(true);
    try {
      const eventData = localStorage.getItem("eventData");
      if (!eventData) throw new Error("Event not found");
  
      const eventId = JSON.parse(eventData).eventId;
  
      const formData = new FormData();
      formData.append("eventId", eventId);
      formData.append("name", lineup.name);
      formData.append("tagLine", lineup.tagLine || "");
      formData.append("description", lineup.description || "");
      formData.append("isActive", "true");
  
      // Handle image
      if (lineup.artistImage instanceof File) {
        formData.append("artistImage", lineup.artistImage);
        console.log("New image file detected:", lineup.artistImage);
      }
      // Handle social media links array
      if (Array.isArray(lineup.socialMedia)) {
        lineup.socialMedia.forEach((social, index) => {
          formData.append(`socialMedia[${index}][url]`, social.url || "");
          formData.append(`socialMedia[${index}][platform]`, social.platform || "");
        });
      }
  
      if (editingLineup) {
        const response = await updateLineup(editingLineup.lineupId, formData) as { data: LineupItem };
        toast.success("Lineup updated successfully");
      
        setLineupData(prev =>
          prev.map(l =>
            l.lineupId === editingLineup.lineupId
              ? { ...l, ...response.data, artistImage: response.data.artistImage + "?t=" + new Date().getTime() }
              : l
          )
        );
      } else {
        const response = await createLineup(formData) as { data: LineupItem };
        toast.success("Lineup created successfully");
      
        setLineupData(prev => [...prev, response.data]);
      }

      setIsLineupModalOpen(false);
      setEditingLineup(undefined);
  
    } catch (e: any) {
      console.error("Error saving lineup:", e);
      const apiMessage =
        e?.response?.data?.message ||
        e?.message ||
        "Something went wrong while saving the lineup";
  
      toast.error(apiMessage);
    } finally {
      setIsLoading(false);
    }
  };
  
  
  
  
  const handleDeleteLineup = async (lineupId: string) => {
    setConfirmationDialog({
      isOpen: true,
      title: "Delete Lineup",
      message: "Are you sure you want to permanently delete this lineup?",
      type: "danger",
      confirmText: "Yes, Delete",
      cancelText: "Cancel",
      onConfirm: async () => {
        setIsLoading(true);
        try {
          await deleteLineup(lineupId);
          setLineupData(prev => prev.filter(l => l.lineupId !== lineupId));
        } catch (err) {
          console.error("Error deleting lineup:", err);
        } finally {
          setIsLoading(false);
          setConfirmationDialog(prev => ({ ...prev, isOpen: false }));
        }
      },
      icon: "fa-solid fa-exclamation-triangle",
    });
  };
  const handleToggleLineup = async (lineupId: string, isActive: boolean) => {
    const lineupToUpdate = lineupData.find(l => l.lineupId === lineupId);
    if (!lineupToUpdate) return;
  
    const form = new FormData();
    form.append("lineupId", lineupId);
    form.append("isActive", String(isActive));
  
    setIsLoading(true);
    try {
      const response = await updateLineup(form);
      setLineupData(prev =>
        prev.map(l => (l.lineupId === lineupId ? response.data : l))
      );
    } catch (err) {
      console.error("Error toggling lineup:", err);
    } finally {
      setIsLoading(false);
    }
  };
  
  const [confirmationDialog, setConfirmationDialog] = useState({
    isOpen: false,
    title: '',
    message: '',
    onConfirm: () => {},
    type: 'warning' as 'warning' | 'danger' | 'info' | 'success',
    confirmText: 'Yes, Continue',
    cancelText: 'Cancel',
    icon: 'fa-solid fa-exclamation-triangle',
  });
  // Close confirmation dialog
  const closeConfirmationDialog = () => {
    setConfirmationDialog(prev => ({ ...prev, isOpen: false }));
  };


  return (
    <div className={`contact-list-container ${isNightMode ? 'text-white' : 'text-dark'}`}>
      <Background />
      <ToastContainer autoClose={2000} />
      <PageHeader
        title="Lineup List"
        subtitle="Manage performing artists, speakers, entertainers, and set schedules."
        isLoading={isLoading}
        actions={
          <Button color="danger" onClick={handleAddLineup} className="v3-btn-primary h_40 d-flex align-items-center">
            <i className="fa-solid fa-plus me-2"></i> Add New Lineup
          </Button>
        }
      />

      <div className="mt-4">
                  {isLoading && (
                    <div className="d-flex justify-content-center py-4">
                      <PulseLoader color="#3470ca" size={9} speedMultiplier={1} />
                    </div>
                  )}

                  {lineupData.length > 0 ? (
                    lineupData.map((lineup) => (
                      <ListCard
                        key={lineup.lineupId}
                        cardData={{
                          icon: "fa-solid fa-microphone-lines",
                          name: lineup.name,
                          ticket: lineup.tagLine || "—",
                          description: lineup.description || "No description available",
                          startDate: lineup.createdDate,
                          status: lineup.isActive ? "Active" : "Inactive",
                        }}
                        onEdit={() => handleEditLineup(lineup)}
                        onDelete={() => handleDeleteLineup(lineup.lineupId)}
                      />
                    ))
                  ) : (
                    !isLoading && (
                      <p className="text-muted text-center py-3">No lineups available</p>
                    )
                  )}
                </div>
                {/* === Image Cropper Modal === */}
{isCropperOpen && fileToCrop && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.7)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 3000,
      overflowY: "auto",
      padding: "20px",
    }}
  >
    <div
      style={{
        backgroundColor: "#fff",
        padding: "20px",
        borderRadius: "10px",
        boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
        maxWidth: "600px",
        width: "90%",
        maxHeight: "90vh",
        overflowY: "auto",
      }}
    >
      <ImageCropper
        imageFile={fileToCrop}
        aspect={3 / 4} // ✅ 3:4 portrait ratio
        onCropComplete={(croppedImg) => {
          const croppedFile = new File([croppedImg], fileToCrop.name, {
            type: fileToCrop.type,
          });

          // Save to your lineup state
          setEditingLineup((prev) => ({
            ...prev!,
            artistImage: croppedFile,
          }));

          setIsCropperOpen(false);
        }}
      />

      {/* Buttons row */}
      <div
        style={{
          marginTop: "20px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "5px",
        }}
      >
        <button
          className="btn btn-outline-danger"
          onClick={() => setIsCropperOpen(false)}
          style={{
            minWidth: "85px",
            height: "32px",
            borderRadius: "8px",
            fontWeight: "500",
            fontSize: "14px",
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
)}

          <LineupModal
        isOpen={isLineupModalOpen}
        toggle={() => setIsLineupModalOpen(false)}
        onSubmit={handleSaveLineup}
        isLoading={isLoading}
        lineup={editingLineup}
      />
            <ConfirmationDialog
        isOpen={confirmationDialog.isOpen}
        toggle={closeConfirmationDialog}
        onConfirm={confirmationDialog.onConfirm}
        title={confirmationDialog.title}
        message={confirmationDialog.message}
        type={confirmationDialog.type}
        confirmText={confirmationDialog.confirmText}
        cancelText={confirmationDialog.cancelText}
        icon={confirmationDialog.icon}
      />
        </div>
      )
    }
    export default Lineup